import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import styles from "./staticPage.module.css";
import thankYou from "../../Images/thank-you.svg";
import takeAwayFood from "../../Images/takeaway-food-icon.svg";
import crossImage from "../../Images/crossImage.jpeg";
import tickImage from "../../Images/tickImage.svg";
import mailIcon from "../../Images/mailIcon.svg";

import order from "../../Images/order.png";
import Success from "../../Images/success.png";
import orderPacket from "../../Images/bag.png";
import { qrSocket } from "../../socket/socket";
import { useLocation, useNavigate } from "react-router-dom";
import { getItem } from "../../utility/localStorageControl";
function OrderCompletePage() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [socketResponse, setSocketResponse] = useState(null);
  const { orderId } = location.state || {};
  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }, []);

  useEffect(() => {
    if (orderId) {
      setLoading(true);
      qrSocket?.on(
        `send_notification_qr_order_accept/${orderId}`,
        async (details) => {
          console.log("details", details);
          setLoading(false);
          setSocketResponse(details);
        }
      );
    }
  }, [orderId]);
  return (
    <div className={styles.orderCompleteBox}>
      <div className={styles.orderCompleteContent}>
        <div className={styles.textWrapper}>
          <p className={styles.orderCompleteText}>
            {loading
              ? "✅ Your order has been placed"
              : socketResponse
              ? socketResponse?.status == "accept"
                ? "🎉 Your order is accepted"
                : "⚠️ Your order was not accepted"
              : "📩 We will update you by email"}
          </p>
        </div>

        <div className={styles.thanksForOrder}>
          <img
            src={
              loading
                ? takeAwayFood
                : socketResponse
                ? socketResponse?.status == "accept"
                  ? tickImage
                  : crossImage
                : mailIcon
            }
            alt="image..."
          />
        </div>
        <p className={styles.thankYouText}>
          {loading
            ? "We have received your order. Please stay on this screen while the restaurant confirms it."
            : socketResponse
            ? socketResponse?.status == "accept"
              ? "The restaurant has accepted your order. It is now being prepared."
              : "The restaurant was unable to accept your order. Please try again or contact the restaurant for assistance."
            : "You've left the order screen. We will email you the order status as soon as the restaurant updates it."}
        </p>
        <button
          className={styles.orderAgainBtn}
          onClick={() => navigate(`/app/${getItem("table_id")}`)}
        >
          Order Again
        </button>
      </div>
    </div>
  );
}

export default OrderCompletePage;
